<script>
    import _01 from "../assets/systems/1.svg";
    import _02 from "../assets/systems/2.svg";

    import { mapGetters, mapActions } from "vuex";
    import FBreadcrumb from "./FBreadcrumb";
    import FBottomSheet from "./FBottomSheet";

    export default {
        name: "FHeader",
        props: {
            tipoModulo: {
                type: Number,
                default: 0
            },

            isDarkThemeActive: {
                type: Boolean,
                default: false
            },

            renderMenuIcon: {
                type: Boolean,
                default: false
            }
        },

        components: {
            FBreadcrumb,
            FBottomSheet
        },

        methods: {
            ...mapActions(["signOut"])
        },

        computed: {
            ...mapGetters(["companySelected", "loading", "user"]),

            tipoModuloIcon() {
                const available = [_01, _02];

                return available[this.companySelected.tipoModulo - 1];
            },

            menuOptions() {
                const options = [
                    {
                        id: 2,
                        title: `Tema ${
                            this.isDarkThemeActive ? "claro" : "escuro"
                        }`,
                        action: () => this.$emit("toggle-theme")
                    },
                    {
                        id: 3,
                        title: "Sair",
                        action: this.signOut
                    }
                ];

                if (this.user.pessoa.tipoPapel >= 32) {
                    options.unshift({
                        id: 1,
                        title: "Senha Técnica",
                        action: () => this.$router.push("/tecnico")
                    });
                }

                return options;
            }
        }
    };
</script>

<template>
    <v-toolbar app extended flat class="fluid__toolbar">
        <img :src="tipoModuloIcon" class="fluid__toolbar__logo" alt="Logo do Modulo de Sistema">

        <FBottomSheet v-if="renderMenuIcon"/>
        <v-spacer/>

        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" aria-hidden="true">
                    <v-icon>more_vert</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-tile v-for="(item, i) in menuOptions" :key="i">
                    <v-list-tile-title @click="item.action" style="cursor: pointer">{{ item.title }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>

        <template v-slot:extension>
            <div style="width: 100%;">
                <FBreadcrumb/>
                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    height="3"
                    style="z-index: 2; padding: 0; margin: 0; bottom: 0; left: 0;position: absolute; "
                />
            </div>
        </template>
    </v-toolbar>
</template>

<style scoped>
    .fluid__toolbar {
        border-bottom: 1px solid #ccc;
        z-index: 20;
    }

    .theme--dark.v-toolbar.fluid__toolbar {
        border-bottom: 1px solid #000 !important;
    }

    .fluid__toolbar__logo {
        width: 70px;
        height: 50px;
    }

    .theme--dark.v-toolbar .fluid__toolbar__logo {
        filter: brightness(0) invert(1);
    }

    /* overrides */
    .theme--light.v-toolbar {
        background-color: white !important;
    }
</style>